import { Icon, IconProps } from '@chakra-ui/react'

export default function CalendarPersonIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        d="M6.24497 2.99707V5.49811"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7489 2.99707V5.49811"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16554 18.0028H4.99714C3.61585 18.0028 2.49609 16.883 2.49609 15.5018V6.74811C2.49609 5.36682 3.61585 4.24707 4.99714 4.24707H15.0013C16.3826 4.24707 17.5023 5.36682 17.5023 6.74811V7.99863"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.58173 13.8338H8.74805"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.24497 13.7296C6.18741 13.7296 6.14076 13.7763 6.14076 13.8338C6.14076 13.8914 6.18741 13.938 6.24497 13.938C6.30252 13.938 6.34918 13.8914 6.34918 13.8338C6.34918 13.7763 6.30252 13.7296 6.24497 13.7296"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8322 10.4998H8.74805"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.24497 10.3956C6.18741 10.3956 6.14076 10.4423 6.14076 10.4998C6.14076 10.5574 6.18741 10.6041 6.24497 10.6041C6.30252 10.6041 6.34918 10.5574 6.34918 10.4998C6.34918 10.4423 6.30252 10.3956 6.24497 10.3956"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 17.5862V17.2477C12.5027 16.2847 13.2827 15.5047 14.2457 15.502H16.59C17.553 15.5047 18.333 16.2847 18.3358 17.2477V17.5862C18.3358 17.8164 18.1491 18.003 17.9189 18.003H12.9168C12.6866 18.003 12.5 17.8164 12.5 17.5862Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="15.4174"
        cy="11.9584"
        r="1.66736"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
